import { c as _c } from "react/compiler-runtime";
import type { CommentData } from '@/api/getCommentList';
import { SELECTOR } from '@/constants';
import { CommentCard } from './CommentCard';
interface CommentSkeletonProps {
  initialData?: CommentData;
}
export const CommentSkeletons = t0 => {
  const $ = _c(7);
  const {
    initialData
  } = t0;
  let t1;
  if ($[0] !== initialData) {
    t1 = initialData ?? {};
    $[0] = initialData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    commentList
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className="my-16 h-53"><strong className="my-16 font-600 text-Gray-900 typo-body4">댓글 -</strong></header>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== commentList) {
    t3 = commentList?.map(_temp);
    $[3] = commentList;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <section className="bg-Gray-white px-16 py-24" id={SELECTOR.COMMENT_LIST_TOP}>{t2}<ul className="flex flex-col gap-24">{t3}</ul></section>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp(comment) {
  return <li key={comment.commentId}><CommentCard comment={comment} /></li>;
}